export default __webpack_public_path__ + "static/media/Vooth_Header_Logo.b87302f1.png";